import React, { useState, useEffect } from 'react';
import { Mail, Send, RefreshCw, CheckCircle, AlertTriangle, ShieldCheck, User, DollarSign, Clock, FileText } from 'lucide-react';
import api from '../services/api.js';
import { useAuth } from '../App.jsx';
import toast from 'react-hot-toast';

export default function HerramientasCotizacion() {
  const { user } = useAuth();

  // Estado para envío de prueba
  const [emailPrueba, setEmailPrueba] = useState('nico1993@gmail.com');
  const [enviandoPrueba, setEnviandoPrueba] = useState(false);
  const [resultadoPrueba, setResultadoPrueba] = useState(null);

  // Estado para solicitudes pendientes
  const [pendientes, setPendientes] = useState([]);
  const [cargandoPendientes, setCargandoPendientes] = useState(false);
  const [datosBancarios, setDatosBancarios] = useState(null);
  const [enviandoId, setEnviandoId] = useState(null);
  const [enviandoMasivo, setEnviandoMasivo] = useState(false);

  // Cargar lista al entrar
  useEffect(() => {
    cargarPendientes();
  }, []);

  const handleEnviarPrueba = async (e) => {
    e.preventDefault();
    if (!emailPrueba.trim()) {
      toast.error('Ingresa un correo electrónico.');
      return;
    }

    try {
      setEnviandoPrueba(true);
      setResultadoPrueba(null);
      const { data } = await api.get('/admin/dev/test-cotizacion-mail', {
        params: { to: emailPrueba.trim() }
      });
      setResultadoPrueba(data);
      toast.success(`Correo enviado a ${emailPrueba}`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al enviar correo de prueba.');
    } finally {
      setEnviandoPrueba(false);
    }
  };

  const cargarPendientes = async () => {
    try {
      setCargandoPendientes(true);
      const { data } = await api.get('/admin/dev/cotizaciones-pendientes');
      setPendientes(data.solicitudes || []);
      setDatosBancarios(data.datos_bancarios || null);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al cargar solicitudes pendientes.');
    } finally {
      setCargandoPendientes(false);
    }
  };

  const reenviarIndividual = async (solicitud) => {
    if (!window.confirm(`¿Reenviar cotización a ${solicitud.nombre} (${solicitud.email})?`)) return;

    try {
      setEnviandoId(solicitud.id);
      const { data } = await api.post(`/admin/dev/reenviar-cotizacion/${solicitud.id}`);
      toast.success(data.message || `Correo reenviado a ${solicitud.nombre}`);
      cargarPendientes();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al reenviar cotización.');
    } finally {
      setEnviandoId(null);
    }
  };

  const reenviarMasivo = async () => {
    if (pendientes.length === 0) {
      toast('No hay solicitudes pendientes.');
      return;
    }

    if (!window.confirm(`⚠️ ATENCIÓN: Vas a reenviar el correo de cotización a las ${pendientes.length} solicitudes pendientes con los datos de Banco BCI.\n\n¿Deseas continuar?`)) {
      return;
    }

    try {
      setEnviandoMasivo(true);
      const { data } = await api.post('/admin/dev/reenviar-cotizaciones-pendientes');
      toast.success(`Proceso terminado: ${data.total_exitosos} enviados.`);
      cargarPendientes();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error en el reenvío masivo.');
    } finally {
      setEnviandoMasivo(false);
    }
  };

  return (
    <div style={{ padding: '2rem clamp(16px, 4vw, 48px)', maxWidth: 1200, margin: '0 auto' }}>
      
      {/* Encabezado */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.4rem' }}>
            <ShieldCheck size={28} color="#d4af37" />
            <h1 style={{ fontSize: '1.6rem', margin: 0, color: 'var(--primary-dark)', fontWeight: 800 }}>
              Panel de Cotizaciones & Pagos
            </h1>
          </div>
          <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            Herramienta restringida exclusivamente para <strong>admin@cbr.cl</strong>
          </p>
        </div>
        <div style={{ background: '#f8fafc', padding: '0.5rem 1rem', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: '0.85rem' }}>
          👤 Conectado como: <strong style={{ color: '#003366' }}>{user?.email}</strong>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
        
        {/* TARJETA 1: Envío de Prueba */}
        <div className="glass-card" style={{ padding: '1.5rem' }}>
          <h3 style={{ fontSize: '1.1rem', margin: '0 0 0.8rem', color: 'var(--primary-dark)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <Mail size={18} color="var(--primary)" /> Probar Envío de Cotización
          </h3>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '1.2rem', lineHeight: '1.5' }}>
            Dispara un correo de cotización real vía <strong>Amazon SES</strong> para verificar que los datos del <strong>Banco BCI</strong> lleguen correctamente formateados a la bandeja de entrada.
          </p>

          <form onSubmit={handleEnviarPrueba} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 600 }}>Correo destinatario</label>
              <input
                type="email"
                className="form-control"
                value={emailPrueba}
                onChange={(e) => setEmailPrueba(e.target.value)}
                placeholder="ejemplo@correo.cl"
                required
                disabled={enviandoPrueba}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-sm"
              disabled={enviandoPrueba}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, alignSelf: 'flex-start' }}
            >
              {enviandoPrueba ? (
                <><span className="spinner" style={{ width: 14, height: 14 }} /> Enviando...</>
              ) : (
                <><Send size={15} /> Enviar Correo de Prueba</>
              )}
            </button>
          </form>

          {resultadoPrueba && (
            <div style={{ marginTop: '1.2rem', padding: '1rem', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, fontSize: '0.85rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#166534', fontWeight: 700, marginBottom: '0.5rem' }}>
                <CheckCircle size={16} /> Correo enviado con éxito
              </div>
              <div style={{ color: '#374151', lineHeight: '1.5' }}>
                <div><strong>Banco:</strong> {resultadoPrueba.datos_bancarios_utilizados?.banco}</div>
                <div><strong>Cuenta:</strong> {resultadoPrueba.datos_bancarios_utilizados?.cuenta} ({resultadoPrueba.datos_bancarios_utilizados?.tipo})</div>
                <div><strong>Titular:</strong> {resultadoPrueba.datos_bancarios_utilizados?.titular}</div>
                <div><strong>RUT:</strong> {resultadoPrueba.datos_bancarios_utilizados?.rut}</div>
                <div><strong>Contacto:</strong> {resultadoPrueba.datos_bancarios_utilizados?.contacto}</div>
              </div>
            </div>
          )}
        </div>

        {/* TARJETA 2: Datos Bancarios Vigentes */}
        <div className="glass-card" style={{ padding: '1.5rem', background: '#fffaf0', borderLeft: '4px solid #d4af37' }}>
          <h3 style={{ fontSize: '1.1rem', margin: '0 0 0.8rem', color: '#1a1e38', display: 'flex', alignItems: 'center', gap: 8 }}>
            <DollarSign size={18} color="#d4af37" /> Datos de Transferencia en Plantillas
          </h3>
          <p style={{ fontSize: '0.85rem', color: '#4a5568', marginBottom: '1.2rem', lineHeight: '1.5' }}>
            Esta es la información oficial que los ciudadanos reciben en su correo y visualizan al consultar el estado de su solicitud:
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem', fontSize: '0.88rem', color: '#2d3748' }}>
            <div><strong>Institución:</strong> {datosBancarios?.banco || 'Banco BCI'}</div>
            <div><strong>N° de Cuenta:</strong> {datosBancarios?.cuenta || 'N° 56998023'} (cuenta corriente)</div>
            <div><strong>Titular:</strong> {datosBancarios?.titular || 'don Raúl Hernán Fuentes Jiménez'}</div>
            <div><strong>RUT Titular:</strong> {datosBancarios?.rut || '13.793.838-3'}</div>
            <div><strong>Correo de Recepción:</strong> {datosBancarios?.contacto || 'conservadorsancarlos@hotmail.com'}</div>
          </div>
        </div>

      </div>

      {/* SECCIÓN 3: Solicitudes en Pendiente Pago */}
      <div className="glass-card" style={{ padding: '1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.2rem', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <h3 style={{ fontSize: '1.2rem', margin: '0 0 0.3rem', color: 'var(--primary-dark)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <Clock size={18} color="var(--copper)" /> Solicitudes Pendientes de Pago ({pendientes.length})
            </h3>
            <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--text-muted)' }}>
              Listado de solicitudes con cotización que están esperando transferencia o comprobante.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center' }}>
            <button
              className="btn btn-secondary btn-sm"
              onClick={cargarPendientes}
              disabled={cargandoPendientes}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
            >
              <RefreshCw size={14} className={cargandoPendientes ? 'spinner' : ''} /> Actualizar
            </button>

            {pendientes.length > 0 && (
              <button
                className="btn btn-primary btn-sm"
                onClick={reenviarMasivo}
                disabled={enviandoMasivo || cargandoPendientes}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#059669', borderColor: '#059669' }}
              >
                {enviandoMasivo ? (
                  <><span className="spinner" style={{ width: 14, height: 14 }} /> Reenviando a todos...</>
                ) : (
                  <><Send size={14} /> Reenviar a Todas las Pendientes</>
                )}
              </button>
            )}
          </div>
        </div>

        {cargandoPendientes ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--text-muted)' }}>
            <span className="spinner spinner-lg" />
            <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>Cargando solicitudes...</p>
          </div>
        ) : pendientes.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--text-muted)' }}>
            <CheckCircle size={36} color="var(--success)" style={{ marginBottom: '0.5rem' }} />
            <p style={{ margin: 0, fontWeight: 600 }}>No hay solicitudes en estado 'Pendiente Pago' en este momento.</p>
          </div>
        ) : (
          <div className="table-wrapper">
            <table style={{ width: '100%', fontSize: '0.85rem' }}>
              <thead>
                <tr>
                  <th>Seguimiento</th>
                  <th>Ciudadano</th>
                  <th>Email</th>
                  <th style={{ textAlign: 'center' }}>Total</th>
                  <th style={{ textAlign: 'center' }}>Ítems</th>
                  <th style={{ textAlign: 'center' }}>Fecha</th>
                  <th style={{ textAlign: 'center' }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {pendientes.map((sol) => (
                  <tr key={sol.id}>
                    <td><strong>{sol.numero_seguimiento}</strong></td>
                    <td>{sol.nombre}</td>
                    <td style={{ color: '#2563eb' }}>{sol.email}</td>
                    <td style={{ textAlign: 'center', fontWeight: 700, color: '#166534' }}>
                      ${new Intl.NumberFormat('es-CL').format(sol.total_cotizacion || 0)}
                    </td>
                    <td style={{ textAlign: 'center' }}>{sol.items_count}</td>
                    <td style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
                      {sol.fecha_creacion ? new Date(sol.fecha_creacion).toLocaleDateString('es-CL') : '—'}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="btn btn-sm btn-secondary"
                        style={{ padding: '3px 8px', fontSize: '0.78rem', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                        onClick={() => reenviarIndividual(sol)}
                        disabled={enviandoId === sol.id}
                      >
                        {enviandoId === sol.id ? (
                          <><span className="spinner" style={{ width: 12, height: 12 }} /> Enviando...</>
                        ) : (
                          <><Send size={12} /> Reenviar</>
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </div>
  );
}
